const replaceNullToString = (obj:any) => {
  if (obj) {
      if (Array.isArray(obj)) {
          let list = []
          obj.forEach(item => {
              let val = replaceModelValue(item)
              list.push(val)
          })
          return list
      } else if (typeof (obj) === 'object') {
          return replaceModelValue(obj)
      }
  }
  return obj
}

const  replaceModelValue= (model) => {
  let keys = Object.keys(model)
  let item = {}
  keys.forEach(key => {
      let val = model[key]
      item[key] = val === null || val === undefined ? '' : model[key]
  });
  return item
}
export {
  replaceNullToString
}
